import { client } from '../client';
import { Pricings } from './getPricings';
import { UserRoleName } from './types/UserProfile';

export type GetPricingsByAdminOptions = {
  /** Backward compatibility: when true, use /collector/users/:id/lowest_pricings. */
  collector?: boolean;
  /** Preferred role-scoped routing for staff endpoints. */
  userRole?: string;
};

export const getPricingsByAdmin = async (
  user_id: number,
  organization_id: string,
  options?: GetPricingsByAdminOptions,
): Promise<Pricings[]> => {
  const prefix =
    options?.userRole === UserRoleName.CareAdvisor
      ? 'care_advisor'
      : options?.userRole === UserRoleName.Collector || options?.collector
        ? 'collector'
        : 'admin';
  const { data } = await client.get(
    `/${prefix}/users/${user_id}/lowest_pricings?organization_id=${organization_id}`,
  );

  return data;
};
